import React, { useState } from "react";
import { Modal, Radio, Space, Form, Input } from "antd";
import { useDispatch } from "react-redux";
import {
    updateAddToAdgroupModalData,
    updateAddToAdgroupModalDisplay,
} from "@features/modalSlice";
import { AppDispatch, SubModule } from "@/ts/common-types";
import { GridApi } from "ag-grid-community";
import {
    addSearchTermsToAdgroup,
    getActiveModule,
    setSpinner,
} from "@/ts/utils";

interface IAddToAdgroupModalProps {
    showAddToAdgroupModal: boolean;
    addToAdgroupModalData: GridApi;
}

const AddToAdgroupModal: React.FC<IAddToAdgroupModalProps> = ({
    showAddToAdgroupModal,
    addToAdgroupModalData,
}) => {
    const [radioValue, setRadioValue] = useState<string>("recommended");
    const activeModule = getActiveModule().activeModule || SubModule.OVERVIEW;
    const [customBid, setCustomBid] = useState<string>("");
    const dispatch = useDispatch<AppDispatch>();

    const handleClose = () => {
        dispatch(updateAddToAdgroupModalDisplay(false));
    };

    const handleSubmit = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        setSpinner("add", event, true);
        addSearchTermsToAdgroup(addToAdgroupModalData, activeModule, customBid);
        setSpinner("remove", event, true);
        dispatch(updateAddToAdgroupModalData({} as GridApi));
        dispatch(updateAddToAdgroupModalDisplay(false));
    };

    const ModalHeaderElement = () => (
        <div className="d-flex align-items-center my-1 pb-3">
            <div>Add To AdGroup</div>
        </div>
    );

    return (
        <Modal
            centered
            open={showAddToAdgroupModal}
            title={<ModalHeaderElement />}
            onOk={handleClose}
            onCancel={handleClose}
            width="30vw"
            styles={{
                body: {
                    height: "16vh",
                    overflowY: "auto",
                },
            }}
            footer={[
                <button
                    id="submit-adgroup"
                    data-bs-name="Submit"
                    key="submit"
                    className="btn btn-primary ms-auto mx-3 py-1"
                    type="button"
                    onClick={handleSubmit}
                    disabled={radioValue === "custom" && !customBid}
                >
                    Submit
                </button>,
                <button
                    id="cancel-adgroup"
                    data-bs-name="Cancel"
                    key="cancel"
                    className="btn btn-secondary ms-auto mx-3 py-1"
                    type="button"
                    onClick={handleClose}
                >
                    Cancel
                </button>,
            ]}
        >
            <div style={{ height: "100%" }}>
                <Form>
                    <div className="fs-6 fw-bold">
                        You can choose between following bid types. What do you
                        want to do?
                    </div>
                    <Form.Item>
                        <div className="my-3">
                            <Radio.Group
                                onChange={(e) => {
                                    setRadioValue(e.target.value);
                                }}
                                value={radioValue}
                            >
                                <Space direction="vertical">
                                    <Radio value={"recommended"}>
                                        Use Recommended Bid
                                    </Radio>
                                    <div className="d-flex align-items-center">
                                        <Radio
                                            value={"custom"}
                                            className="w-75"
                                        >
                                            Use Custom Bid:
                                        </Radio>
                                        <Input
                                            disabled={radioValue !== "custom"}
                                            placeholder="Enter Custom Bid"
                                            className="border"
                                            type="number"
                                            value={customBid}
                                            onChange={(e) => {
                                                setCustomBid(e.target.value);
                                            }}
                                        />
                                    </div>
                                </Space>
                            </Radio.Group>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default AddToAdgroupModal;
